import React from 'react'

import { DiscoCallout, Flex } from 'components/ds'

type Props = {
  children: React.ReactNode
  icon?: React.ReactNode
}

/** Renders a centered search error callout announced to assistive technology. */
const SearchErrorCallout = ({ children, icon }: Props) => (
  <Flex width="100%" justify="center">
    <DiscoCallout type="error" variant="soft" size="1" icon={icon} role="alert">
      {children}
    </DiscoCallout>
  </Flex>
)

export default SearchErrorCallout
